// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rc__3x29yq {
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  max-width: 100%;
}

  @media (min-width: 769px) {.rc__3x29yq {
    display: flex
}
  }

  .rc__3x29yq + .rc__3x29yq {
    margin-top: 20px;
  }

.rc__tsrxed {
  display: none;
}

.rc__8p7ne9 {
  position: absolute;
  display: block;
  width: 20px;
  height: 20px;
  top: 0;
  left: 0;
  border-radius: 50%;
  outline: 0 solid transparent;
  border: var(--rc-geo-radio-border);
  background-color: var(--rc-geo-radio-bgColor);
  transition: border 200ms, outline 100ms;
  z-index: 1;
}

.rc__3x29yq:not(.rc__3v2mds):hover .rc__8p7ne9 {
    border: var(--rc-geo-radio-hover-border);
  }

.rc__3x29yq:not(.rc__3v2mds):active .rc__8p7ne9 {
    border: var(--rc-geo-radio-active-border);
    outline: var(--rc-geo-radio-active-outline);
  }

.rc__3v2mds .rc__8p7ne9 {
    border: var(--rc-geo-radio-checked-border);
    background-color: var(--rc-geo-radio-checked-bgColor);
  }

@media (hover: hover) {
    .rc__3v2mds:hover .rc__8p7ne9 {
      border: var(--rc-geo-radio-checked-hover-border);
    }
  }

.rc__3v2mds:active .rc__8p7ne9 {
    border: var(--rc-geo-radio-checked-active-border);
  }

.rc__684r8p,
.rc__ctn1db {
  display: block;
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 20px;
  white-space: nowrap;
  text-overflow: ellipsis;
  transition: color 200ms;
}

.rc__684r8p {
  flex-shrink: 0;
  padding-left: 30px;
  color: var(--rc-geo-radio-label-color);
}

@media (max-width: 768px) {

.rc__684r8p {
    overflow: hidden
}
  }

.rc__ctn1db {
  overflow: hidden;
  color: var(--rc-geo-description-color);
}

@media (max-width: 768px) {

.rc__ctn1db {
    margin-top: 5px
}
  }

@media (min-width: 769px) {

.rc__ctn1db {
    margin-left: 10px
}
  }

.rc__88x9kq {
  position: absolute;
  overflow: hidden;
  display: none;
  top: 45px;
  left: 0;
  right: 0;
  border-radius: 5px;
  background-color: var(--rc-geo-suggest-bgColor);
  box-shadow: var(--rc-geo-suggest-boxShadow);
  z-index: 1;
}

  .rc__88x9kq.rc__8err5v {
    display: block;
  }

.rc__28c2m8 {
  padding: 0;
  border: 0;
  background-color: transparent;
  box-shadow: none;
  cursor: pointer;

  overflow: hidden;
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  padding: 0 15px;
  font-family: "Manrope", sans-serif;
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
  color: var(--rc-geo-suggest-color);
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  background-color: var(--rc-geo-suggest-bgColor);
  transition: color 200ms, background-color 200ms;
  cursor: pointer;
}

.rc__28c2m8.rc__3rb68d {
    color: var(--rc-geo-suggest-hover-color);
    background-color: var(--rc-geo-suggest-hover-bgColor);
  }

.rc__28c2m8:active {
    color: var(--rc-geo-suggest-active-color);
    background-color: var(--rc-geo-suggest-active-bgColor);
  }

.rc__71zu42 {
  padding: 0;
  border: 0;
  background-color: transparent;
  box-shadow: none;
  cursor: pointer;

  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  padding: 0 20px;
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-weight: 700;
  font-style: normal;
  line-height: 20px;
  border-radius: 25px;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  transition: background-color 200ms, color 200ms;
}

  .rc__71zu42:not(.rc__5mrxst).rc__2u7bbj {
    color: var(--rc-geo-button-primary-color);
    background-color: var(--rc-geo-button-primary-bgColor);
  }

  @media (hover: hover) {
      .rc__71zu42:not(.rc__5mrxst).rc__2u7bbj:hover {
        background-color: var(--rc-geo-button-primary-hover-bgColor);
      }
    }

  .rc__71zu42:not(.rc__5mrxst).rc__2u7bbj:active {
      background-color: var(--rc-geo-button-primary-active-bgColor);
    }

  .rc__71zu42:not(.rc__5mrxst).rc__7gykbu {
    color: var(--rc-geo-button-secondary-color);
    background-color: var(--rc-geo-button-secondary-bgColor);
  }

  @media (hover: hover) {
      .rc__71zu42:not(.rc__5mrxst).rc__7gykbu:hover {
        color: var(--rc-geo-button-secondary-hover-color);
        background-color: var(--rc-geo-button-secondary-hover-bgColor);
      }
    }

  .rc__71zu42:not(.rc__5mrxst).rc__7gykbu:active {
      color: var(--rc-geo-button-secondary-active-color);
      background-color: var(--rc-geo-button-secondary-active-bgColor);
    }

  .rc__71zu42.rc__5mrxst {
    color: var(--rc-geo-button-disabled-color);
    background-color: var(--rc-geo-button-disabled-bgColor);
    cursor: default;
    pointer-events: none;
  }

:root, :host {
  --rc-geo-headline-color: #343b4c;
  --rc-geo-description-color: #777e98;
  --rc-geo-loader-color: #315efb;
  --rc-geo-bgColor: #ffffff;

  --rc-geo-input-color: #343b4c;
  --rc-geo-input-bgColor: #eff5ff;
  --rc-geo-input-hover-color: #e0ebff;
  --rc-geo-input-placeholder-color: #777e98;

  --rc-geo-button-primary-color: #ffffff;
  --rc-geo-button-primary-bgColor: #315efb;
  --rc-geo-button-primary-hover-bgColor: #2c54e2;
  --rc-geo-button-primary-active-bgColor: #274bc8;
  --rc-geo-button-secondary-color: #343b4c;
  --rc-geo-button-secondary-bgColor: #e0ebff;
  --rc-geo-button-secondary-hover-color: #2c54e2;
  --rc-geo-button-secondary-hover-bgColor: #d1e2ff;
  --rc-geo-button-secondary-active-color: #274bc8;
  --rc-geo-button-secondary-active-bgColor: #c1d8ff;
  --rc-geo-button-disabled-color: #afb6c9;
  --rc-geo-button-disabled-bgColor: #f3f4f7;

  --rc-geo-radio-label-color: #343b4c;
  --rc-geo-radio-bgColor: #ffffff;
  --rc-geo-radio-border: solid 10px #e0ebff;
  --rc-geo-radio-hover-border: solid 10px #d1e2ff;
  --rc-geo-radio-active-border: solid 10px #c1d8ff;
  --rc-geo-radio-active-outline: solid 5px #eff5ff;
  --rc-geo-radio-checked-border: solid 5px #315efb;
  --rc-geo-radio-checked-hover-border: solid 5px #2c54e2;
  --rc-geo-radio-checked-active-border: solid 5px #274bc8;

  --rc-geo-suggest-color: #343b4c;
  --rc-geo-suggest-bgColor: #eff5ff;
  --rc-geo-suggest-hover-color: #2c54e2;
  --rc-geo-suggest-hover-bgColor: #e0ebff;
  --rc-geo-suggest-active-color: #274bc8;
  --rc-geo-suggest-active-bgColor: #d1e2ff;
  --rc-geo-suggest-boxShadow: 0 10px 30px -5px rgba(49,94,251, 0.25);
  }

:root.dark-mode {
  --rc-geo-headline-color: #eff5ff;
  --rc-geo-description-color: #afb6c9;
  --rc-geo-loader-color: #ffffff;
  --rc-geo-bgColor: #1f2431;

  --rc-geo-input-color: #eff5ff;
  --rc-geo-input-bgColor: #393f51;
  --rc-geo-input-hover-color: #3d4456;
  --rc-geo-input-placeholder-color: #afb6c9;

  --rc-geo-button-primary-color: #ffffff;
  --rc-geo-button-primary-bgColor: #649dff;
  --rc-geo-button-primary-hover-bgColor: #83b1ff;
  --rc-geo-button-primary-active-bgColor: #a2c4ff;
  --rc-geo-button-secondary-color: #eff5ff;
  --rc-geo-button-secondary-bgColor: #3d4456;
  --rc-geo-button-secondary-hover-color: #a2c4ff;
  --rc-geo-button-secondary-hover-bgColor: #464d60;
  --rc-geo-button-secondary-active-color: #83b1ff;
  --rc-geo-button-secondary-active-bgColor: #50566b;
  --rc-geo-button-disabled-color: #62687f;
  --rc-geo-button-disabled-bgColor: #343b4c;

  --rc-geo-radio-label-color: #eff5ff;
  --rc-geo-radio-bgColor: #1f2431;
  --rc-geo-radio-border: solid 10px #3d4456;
  --rc-geo-radio-hover-border: solid 10px #464d60;
  --rc-geo-radio-active-border: solid 10px #50566b;
  --rc-geo-radio-active-outline: solid 5px #393f51;
  --rc-geo-radio-checked-bgColor: #ffffff;
  --rc-geo-radio-checked-border: solid 5px #649dff;
  --rc-geo-radio-checked-hover-border: solid 5px #83b1ff;
  --rc-geo-radio-checked-active-border: solid 5px #a2c4ff;

  --rc-geo-suggest-color: #eff5ff;
  --rc-geo-suggest-bgColor: #393f51;
  --rc-geo-suggest-hover-color: #a2c4ff;
  --rc-geo-suggest-hover-bgColor: #3d4456;
  --rc-geo-suggest-active-color: #83b1ff;
  --rc-geo-suggest-active-bgColor: #464d60;
  --rc-geo-suggest-boxShadow: 0 10px 30px -5px rgba(13,16,23, 0.6);
  }

.rc__8fetqu {
  display: flex;
  flex-direction: column;
}

.rc__dsy747 {
  margin: 0 0 20px;
  font-family: "Manrope", sans-serif;
  font-style: normal;
  font-weight: 800;
  font-size: 21px;
  line-height: 30px;
  color: var(--rc-geo-headline-color);
}

.rc__5pucg7 {
  position: relative;
}

.rc__3358w9 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.rc__3j4uct {
  position: relative;
  margin-top: 20px;
}

.rc__3qgguz {
  width: 100%;
  height: 40px;
  padding: 0 15px;
  font-family: "Manrope", sans-serif;
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
  color: var(--rc-geo-input-color);
  border: 0;
  outline: 0;
  border-radius: 5px;
  background-color: var(--rc-geo-input-bgColor);
  transition: background-color 200ms;
}

@media (hover: hover) {
    .rc__3qgguz:hover {
      background-color: var(--rc-geo-input-hover-color);
    }
  }

.rc__3qgguz:focus {
    background-color: var(--rc-geo-input-hover-color);
  }

.rc__3qgguz::-moz-placeholder {
    color: var(--rc-geo-input-placeholder-color);
  }

.rc__3qgguz::placeholder {
    color: var(--rc-geo-input-placeholder-color);
  }

.rc__21ktzw {
  margin-top: 5px;
  font-family: "Manrope", sans-serif;
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
  color: var(--rc-geo-description-color);
}

.rc__568g2u {
  display: flex;
  margin-top: 20px;
}

@media (max-width: 768px) {

.rc__568g2u {
    flex-wrap: wrap
}
  }

@media (max-width: 768px) {

.rc__568g2u button {
      width: 100%
  }
    }

@media (max-width: 768px) {

.rc__4pubfy {
    display: none
}
  }

@media (min-width: 769px) {

.rc__4pubfy {
    margin-left: 20px
}
  }

.rc__7netm1 {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--rc-geo-bgColor);
  z-index: 1;
}

.rc__34t2yj {
  display: block;
  width: 61px;
  height: 61px;
  color: var(--rc-geo-loader-color);
}

`, "",{"version":3,"sources":["webpack://./node_modules/@rambler-components/geo/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;KACtB,sBAAsB;UACjB,iBAAiB;EACzB,eAAe;AACjB;;EAEE,2BAA2B;IACzB;AACJ;EACE;;EAEA;IACE,gBAAgB;EAClB;;AAEF;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,kBAAkB;EAClB,4BAA4B;EAC5B,kCAAkC;EAClC,6CAA6C;EAC7C,uCAAuC;EACvC,UAAU;AACZ;;AAEA;IACI,wCAAwC;EAC1C;;AAEF;IACI,yCAAyC;IACzC,2CAA2C;EAC7C;;AAEF;IACI,0CAA0C;IAC1C,qDAAqD;EACvD;;AAEF;IACI;MACE,gDAAgD;IAClD;EACF;;AAEF;IACI,iDAAiD;EACnD;;AAEF;;EAEE,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;;AAEA;IACI;AACJ;EACE;;AAEF;EACE,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;;AAEA;IACI;AACJ;EACE;;AAEF;;AAEA;IACI;AACJ;EACE;;AAEF;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,+CAA+C;EAC/C,2CAA2C;EAC3C,UAAU;AACZ;;EAEE;IACE,cAAc;EAChB;;AAEF;EACE,UAAU;EACV,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;;EAEf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,+CAA+C;EAC/C,+CAA+C;EAC/C,eAAe;AACjB;;AAEA;IACI,wCAAwC;IACxC,qDAAqD;EACvD;;AAEF;IACI,yCAAyC;IACzC,sDAAsD;EACxD;;AAEF;EACE,UAAU;EACV,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;;EAEf,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;KACtB,sBAAsB;UACjB,iBAAiB;EACzB,+CAA+C;AACjD;;EAEE;IACE,yCAAyC;IACzC,sDAAsD;EACxD;;EAEA;MACI;QACE,4DAA4D;MAC9D;IACF;;EAEF;MACI,6DAA6D;IAC/D;;EAEF;IACE,2CAA2C;IAC3C,wDAAwD;EAC1D;;EAEA;MACI;QACE,iDAAiD;QACjD,8DAA8D;MAChE;IACF;;EAEF;MACI,kDAAkD;MAClD,+DAA+D;IACjE;;EAEF;IACE,0CAA0C;IAC1C,uDAAuD;IACvD,eAAe;IACf,oBAAoB;EACtB;;AAEF;EACE,gCAAgC;EAChC,mCAAmC;EACnC,8BAA8B;EAC9B,yBAAyB;;EAEzB,6BAA6B;EAC7B,+BAA+B;EAC/B,mCAAmC;EACnC,yCAAyC;;EAEzC,sCAAsC;EACtC,wCAAwC;EACxC,8CAA8C;EAC9C,+CAA+C;EAC/C,wCAAwC;EACxC,0CAA0C;EAC1C,8CAA8C;EAC9C,gDAAgD;EAChD,+CAA+C;EAC/C,iDAAiD;EACjD,uCAAuC;EACvC,yCAAyC;;EAEzC,mCAAmC;EACnC,+BAA+B;EAC/B,yCAAyC;EACzC,+CAA+C;EAC/C,gDAAgD;EAChD,gDAAgD;EAChD,gDAAgD;EAChD,sDAAsD;EACtD,uDAAuD;;EAEvD,+BAA+B;EAC/B,iCAAiC;EACjC,qCAAqC;EACrC,uCAAuC;EACvC,sCAAsC;EACtC,wCAAwC;EACxC,kEAAkE;EAClE;;AAEF;EACE,gCAAgC;EAChC,mCAAmC;EACnC,8BAA8B;EAC9B,yBAAyB;;EAEzB,6BAA6B;EAC7B,+BAA+B;EAC/B,mCAAmC;EACnC,yCAAyC;;EAEzC,sCAAsC;EACtC,wCAAwC;EACxC,8CAA8C;EAC9C,+CAA+C;EAC/C,wCAAwC;EACxC,0CAA0C;EAC1C,8CAA8C;EAC9C,gDAAgD;EAChD,+CAA+C;EAC/C,iDAAiD;EACjD,uCAAuC;EACvC,yCAAyC;;EAEzC,mCAAmC;EACnC,+BAA+B;EAC/B,yCAAyC;EACzC,+CAA+C;EAC/C,gDAAgD;EAChD,gDAAgD;EAChD,uCAAuC;EACvC,gDAAgD;EAChD,sDAAsD;EACtD,uDAAuD;;EAEvD,+BAA+B;EAC/B,iCAAiC;EACjC,qCAAqC;EACrC,uCAAuC;EACvC,sCAAsC;EACtC,wCAAwC;EACxC,gEAAgE;EAChE;;AAEF;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,6CAA6C;EAC7C,kCAAkC;AACpC;;AAEA;IACI;MACE,iDAAiD;IACnD;EACF;;AAEF;IACI,iDAAiD;EACnD;;AAEF;IACI,4CAA4C;EAC9C;;AAEF;IACI,4CAA4C;EAC9C;;AAEF;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;;AAEA;IACI;AACJ;EACE;;AAEF;;AAEA;MACM;EACJ;IACE;;AAEJ;;AAEA;IACI;AACJ;EACE;;AAEF;;AAEA;IACI;AACJ;EACE;;AAEF;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,uCAAuC;EACvC,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC","sourcesContent":[".rc__3x29yq {\n  position: relative;\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n  max-width: 100%;\n}\n\n  @media (min-width: 769px) {.rc__3x29yq {\n    display: flex\n}\n  }\n\n  .rc__3x29yq + .rc__3x29yq {\n    margin-top: 20px;\n  }\n\n.rc__tsrxed {\n  display: none;\n}\n\n.rc__8p7ne9 {\n  position: absolute;\n  display: block;\n  width: 20px;\n  height: 20px;\n  top: 0;\n  left: 0;\n  border-radius: 50%;\n  outline: 0 solid transparent;\n  border: var(--rc-geo-radio-border);\n  background-color: var(--rc-geo-radio-bgColor);\n  transition: border 200ms, outline 100ms;\n  z-index: 1;\n}\n\n.rc__3x29yq:not(.rc__3v2mds):hover .rc__8p7ne9 {\n    border: var(--rc-geo-radio-hover-border);\n  }\n\n.rc__3x29yq:not(.rc__3v2mds):active .rc__8p7ne9 {\n    border: var(--rc-geo-radio-active-border);\n    outline: var(--rc-geo-radio-active-outline);\n  }\n\n.rc__3v2mds .rc__8p7ne9 {\n    border: var(--rc-geo-radio-checked-border);\n    background-color: var(--rc-geo-radio-checked-bgColor);\n  }\n\n@media (hover: hover) {\n    .rc__3v2mds:hover .rc__8p7ne9 {\n      border: var(--rc-geo-radio-checked-hover-border);\n    }\n  }\n\n.rc__3v2mds:active .rc__8p7ne9 {\n    border: var(--rc-geo-radio-checked-active-border);\n  }\n\n.rc__684r8p,\n.rc__ctn1db {\n  display: block;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 20px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  transition: color 200ms;\n}\n\n.rc__684r8p {\n  flex-shrink: 0;\n  padding-left: 30px;\n  color: var(--rc-geo-radio-label-color);\n}\n\n@media (max-width: 768px) {\n\n.rc__684r8p {\n    overflow: hidden\n}\n  }\n\n.rc__ctn1db {\n  overflow: hidden;\n  color: var(--rc-geo-description-color);\n}\n\n@media (max-width: 768px) {\n\n.rc__ctn1db {\n    margin-top: 5px\n}\n  }\n\n@media (min-width: 769px) {\n\n.rc__ctn1db {\n    margin-left: 10px\n}\n  }\n\n.rc__88x9kq {\n  position: absolute;\n  overflow: hidden;\n  display: none;\n  top: 45px;\n  left: 0;\n  right: 0;\n  border-radius: 5px;\n  background-color: var(--rc-geo-suggest-bgColor);\n  box-shadow: var(--rc-geo-suggest-boxShadow);\n  z-index: 1;\n}\n\n  .rc__88x9kq.rc__8err5v {\n    display: block;\n  }\n\n.rc__28c2m8 {\n  padding: 0;\n  border: 0;\n  background-color: transparent;\n  box-shadow: none;\n  cursor: pointer;\n\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 40px;\n  padding: 0 15px;\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 500;\n  font-size: 15px;\n  line-height: 20px;\n  color: var(--rc-geo-suggest-color);\n  text-align: left;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  background-color: var(--rc-geo-suggest-bgColor);\n  transition: color 200ms, background-color 200ms;\n  cursor: pointer;\n}\n\n.rc__28c2m8.rc__3rb68d {\n    color: var(--rc-geo-suggest-hover-color);\n    background-color: var(--rc-geo-suggest-hover-bgColor);\n  }\n\n.rc__28c2m8:active {\n    color: var(--rc-geo-suggest-active-color);\n    background-color: var(--rc-geo-suggest-active-bgColor);\n  }\n\n.rc__71zu42 {\n  padding: 0;\n  border: 0;\n  background-color: transparent;\n  box-shadow: none;\n  cursor: pointer;\n\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  height: 40px;\n  padding: 0 20px;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-weight: 700;\n  font-style: normal;\n  line-height: 20px;\n  border-radius: 25px;\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n  transition: background-color 200ms, color 200ms;\n}\n\n  .rc__71zu42:not(.rc__5mrxst).rc__2u7bbj {\n    color: var(--rc-geo-button-primary-color);\n    background-color: var(--rc-geo-button-primary-bgColor);\n  }\n\n  @media (hover: hover) {\n      .rc__71zu42:not(.rc__5mrxst).rc__2u7bbj:hover {\n        background-color: var(--rc-geo-button-primary-hover-bgColor);\n      }\n    }\n\n  .rc__71zu42:not(.rc__5mrxst).rc__2u7bbj:active {\n      background-color: var(--rc-geo-button-primary-active-bgColor);\n    }\n\n  .rc__71zu42:not(.rc__5mrxst).rc__7gykbu {\n    color: var(--rc-geo-button-secondary-color);\n    background-color: var(--rc-geo-button-secondary-bgColor);\n  }\n\n  @media (hover: hover) {\n      .rc__71zu42:not(.rc__5mrxst).rc__7gykbu:hover {\n        color: var(--rc-geo-button-secondary-hover-color);\n        background-color: var(--rc-geo-button-secondary-hover-bgColor);\n      }\n    }\n\n  .rc__71zu42:not(.rc__5mrxst).rc__7gykbu:active {\n      color: var(--rc-geo-button-secondary-active-color);\n      background-color: var(--rc-geo-button-secondary-active-bgColor);\n    }\n\n  .rc__71zu42.rc__5mrxst {\n    color: var(--rc-geo-button-disabled-color);\n    background-color: var(--rc-geo-button-disabled-bgColor);\n    cursor: default;\n    pointer-events: none;\n  }\n\n:root, :host {\n  --rc-geo-headline-color: #343b4c;\n  --rc-geo-description-color: #777e98;\n  --rc-geo-loader-color: #315efb;\n  --rc-geo-bgColor: #ffffff;\n\n  --rc-geo-input-color: #343b4c;\n  --rc-geo-input-bgColor: #eff5ff;\n  --rc-geo-input-hover-color: #e0ebff;\n  --rc-geo-input-placeholder-color: #777e98;\n\n  --rc-geo-button-primary-color: #ffffff;\n  --rc-geo-button-primary-bgColor: #315efb;\n  --rc-geo-button-primary-hover-bgColor: #2c54e2;\n  --rc-geo-button-primary-active-bgColor: #274bc8;\n  --rc-geo-button-secondary-color: #343b4c;\n  --rc-geo-button-secondary-bgColor: #e0ebff;\n  --rc-geo-button-secondary-hover-color: #2c54e2;\n  --rc-geo-button-secondary-hover-bgColor: #d1e2ff;\n  --rc-geo-button-secondary-active-color: #274bc8;\n  --rc-geo-button-secondary-active-bgColor: #c1d8ff;\n  --rc-geo-button-disabled-color: #afb6c9;\n  --rc-geo-button-disabled-bgColor: #f3f4f7;\n\n  --rc-geo-radio-label-color: #343b4c;\n  --rc-geo-radio-bgColor: #ffffff;\n  --rc-geo-radio-border: solid 10px #e0ebff;\n  --rc-geo-radio-hover-border: solid 10px #d1e2ff;\n  --rc-geo-radio-active-border: solid 10px #c1d8ff;\n  --rc-geo-radio-active-outline: solid 5px #eff5ff;\n  --rc-geo-radio-checked-border: solid 5px #315efb;\n  --rc-geo-radio-checked-hover-border: solid 5px #2c54e2;\n  --rc-geo-radio-checked-active-border: solid 5px #274bc8;\n\n  --rc-geo-suggest-color: #343b4c;\n  --rc-geo-suggest-bgColor: #eff5ff;\n  --rc-geo-suggest-hover-color: #2c54e2;\n  --rc-geo-suggest-hover-bgColor: #e0ebff;\n  --rc-geo-suggest-active-color: #274bc8;\n  --rc-geo-suggest-active-bgColor: #d1e2ff;\n  --rc-geo-suggest-boxShadow: 0 10px 30px -5px rgba(49,94,251, 0.25);\n  }\n\n:root.dark-mode {\n  --rc-geo-headline-color: #eff5ff;\n  --rc-geo-description-color: #afb6c9;\n  --rc-geo-loader-color: #ffffff;\n  --rc-geo-bgColor: #1f2431;\n\n  --rc-geo-input-color: #eff5ff;\n  --rc-geo-input-bgColor: #393f51;\n  --rc-geo-input-hover-color: #3d4456;\n  --rc-geo-input-placeholder-color: #afb6c9;\n\n  --rc-geo-button-primary-color: #ffffff;\n  --rc-geo-button-primary-bgColor: #649dff;\n  --rc-geo-button-primary-hover-bgColor: #83b1ff;\n  --rc-geo-button-primary-active-bgColor: #a2c4ff;\n  --rc-geo-button-secondary-color: #eff5ff;\n  --rc-geo-button-secondary-bgColor: #3d4456;\n  --rc-geo-button-secondary-hover-color: #a2c4ff;\n  --rc-geo-button-secondary-hover-bgColor: #464d60;\n  --rc-geo-button-secondary-active-color: #83b1ff;\n  --rc-geo-button-secondary-active-bgColor: #50566b;\n  --rc-geo-button-disabled-color: #62687f;\n  --rc-geo-button-disabled-bgColor: #343b4c;\n\n  --rc-geo-radio-label-color: #eff5ff;\n  --rc-geo-radio-bgColor: #1f2431;\n  --rc-geo-radio-border: solid 10px #3d4456;\n  --rc-geo-radio-hover-border: solid 10px #464d60;\n  --rc-geo-radio-active-border: solid 10px #50566b;\n  --rc-geo-radio-active-outline: solid 5px #393f51;\n  --rc-geo-radio-checked-bgColor: #ffffff;\n  --rc-geo-radio-checked-border: solid 5px #649dff;\n  --rc-geo-radio-checked-hover-border: solid 5px #83b1ff;\n  --rc-geo-radio-checked-active-border: solid 5px #a2c4ff;\n\n  --rc-geo-suggest-color: #eff5ff;\n  --rc-geo-suggest-bgColor: #393f51;\n  --rc-geo-suggest-hover-color: #a2c4ff;\n  --rc-geo-suggest-hover-bgColor: #3d4456;\n  --rc-geo-suggest-active-color: #83b1ff;\n  --rc-geo-suggest-active-bgColor: #464d60;\n  --rc-geo-suggest-boxShadow: 0 10px 30px -5px rgba(13,16,23, 0.6);\n  }\n\n.rc__8fetqu {\n  display: flex;\n  flex-direction: column;\n}\n\n.rc__dsy747 {\n  margin: 0 0 20px;\n  font-family: \"Manrope\", sans-serif;\n  font-style: normal;\n  font-weight: 800;\n  font-size: 21px;\n  line-height: 30px;\n  color: var(--rc-geo-headline-color);\n}\n\n.rc__5pucg7 {\n  position: relative;\n}\n\n.rc__3358w9 {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.rc__3j4uct {\n  position: relative;\n  margin-top: 20px;\n}\n\n.rc__3qgguz {\n  width: 100%;\n  height: 40px;\n  padding: 0 15px;\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 500;\n  font-size: 15px;\n  line-height: 20px;\n  color: var(--rc-geo-input-color);\n  border: 0;\n  outline: 0;\n  border-radius: 5px;\n  background-color: var(--rc-geo-input-bgColor);\n  transition: background-color 200ms;\n}\n\n@media (hover: hover) {\n    .rc__3qgguz:hover {\n      background-color: var(--rc-geo-input-hover-color);\n    }\n  }\n\n.rc__3qgguz:focus {\n    background-color: var(--rc-geo-input-hover-color);\n  }\n\n.rc__3qgguz::-moz-placeholder {\n    color: var(--rc-geo-input-placeholder-color);\n  }\n\n.rc__3qgguz::placeholder {\n    color: var(--rc-geo-input-placeholder-color);\n  }\n\n.rc__21ktzw {\n  margin-top: 5px;\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 500;\n  font-size: 15px;\n  line-height: 20px;\n  color: var(--rc-geo-description-color);\n}\n\n.rc__568g2u {\n  display: flex;\n  margin-top: 20px;\n}\n\n@media (max-width: 768px) {\n\n.rc__568g2u {\n    flex-wrap: wrap\n}\n  }\n\n@media (max-width: 768px) {\n\n.rc__568g2u button {\n      width: 100%\n  }\n    }\n\n@media (max-width: 768px) {\n\n.rc__4pubfy {\n    display: none\n}\n  }\n\n@media (min-width: 769px) {\n\n.rc__4pubfy {\n    margin-left: 20px\n}\n  }\n\n.rc__7netm1 {\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: var(--rc-geo-bgColor);\n  z-index: 1;\n}\n\n.rc__34t2yj {\n  display: block;\n  width: 61px;\n  height: 61px;\n  color: var(--rc-geo-loader-color);\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
